// extracted by mini-css-extract-plugin
export default {"base":"vp_skwHn","tip":"vp_VKNWd"};